module.exports = __webpack_public_path__ + "static/media/avatar.9a3a77b0.svg";